import { awaitPromise } from "../fable_modules/fable-library.3.7.12/Async.js";
import { result } from "../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";

export function ofPromise() {
    return (arg) => awaitPromise(result(arg));
}

